import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import NumericInput from 'react-numeric-input';

import InputWrapper from '../../common/InputWrapper';

import { getCurrencySymbol } from '../../../helpers';

import { VAT_RATES } from '../../../config';
import Checkbox from '../../common/Checkbox';
import Select from '../../common/Select';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .react-numeric-input {
    flex: 1 1;
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;
const SelectWrap = styled('div')`
  .react-select__control {
    height: 36px;
  }
`;

const discountTypes = [
  {
    value: 'PERCENT',
    label: '%',
  },
  {
    value: 'FIX',
    label: 'Фикс',
  },
];

const PriceBlockWithAutoCalc = (props) => {
  const { values, handleChangeInput } = props;

  const { checkoutSettings, priceSettings } = useSelector((state) => state.settings);
  const [discountType, setdiscountType] = useState('FIX');

  const { t } = useAutoTranslation();

  const handleChangePrice = (value, priceType) => {
    const isExist = Boolean(values.prices[priceType.code]);
    const newPrice = isExist
      ? {
          ...values.prices[priceType.code],
          value,
        }
      : {
          priceCode: priceType.code,
          priceName: priceType.name,
          value,
        };

    handleChangeInput('prices', {
      ...values.prices,
      [priceType.code]: newPrice,
    });
  };

  const basicPrice = priceSettings.find((p) => p.name === 'Розничная цена');
  const beforeDiscountPrice = priceSettings.find((p) => p.name === 'Цена до скидки');

  useEffect(() => {
    if (values.autoPriceCalculation && values.discountPercent) {
      setdiscountType('PERCENT');
    }
  }, [values.discountPercent, values.autoPriceCalculation]);

  const handleChangeDiscount = (input, value) => {
    if (input === 'discountFix') {
      handleChangeInput('discountFix', value);
      handleChangeInput('discountPercent', 0);
    } else {
      handleChangeInput('discountPercent', value);
      handleChangeInput('discountFix', 0);
    }
  };

  return (
    <Wrapper className="card-box" style={{ height: 'auto' }}>
      <div className="row d-flex justify-content-between">
        <div className="col-md-4">
          <h4 className="header-title">{t('Цены')}</h4>
        </div>
        <div className="col-md-4 d-flex justify-content-md-end mb-md-0 mb-2">
          <Checkbox
            id="autoСalc"
            label={t('Авторасчет цены')}
            labelQuestion={t('Авторасчет цены')}
            checked={values.autoPriceCalculation}
            onChange={(e) => handleChangeInput('autoPriceCalculation', e.target.checked)}
          />
        </div>
      </div>
      <div className="row">
        {basicPrice ? (
          <div className="col-md-6">
            <div className="form-group">
              <InputWrapper
                type="text"
                label={t('Цена')}
                id="price"
                value={
                  values.prices[t('Розничная цена')] ? values.prices[t('Розничная цена')].value : ''
                }
                onChange={(valueAsNumber) => handleChangePrice(valueAsNumber, basicPrice)}
                textAppend={getCurrencySymbol(basicPrice?.currency)}
                placeholder={t('Введите цену')}
                component={NumericInput}
                componentProps={{ precision: 2, style: false }}
                readOnly={values.autoPriceCalculation}
              />
            </div>
          </div>
        ) : null}
        {beforeDiscountPrice ? (
          <div className="col-md-6">
            <div className="form-group">
              <InputWrapper
                type="text"
                label={t('Цена до скидки')}
                id="oldPrice"
                value={
                  values.prices[t('Цена до скидки')] ? values.prices[t('Цена до скидки')].value : ''
                }
                onChange={(valueAsNumber) => handleChangePrice(valueAsNumber, beforeDiscountPrice)}
                textAppend={getCurrencySymbol(beforeDiscountPrice?.currency)}
                placeholder={t('Введите цену до скидки')}
                component={NumericInput}
                componentProps={{ precision: 2, style: false }}
                readOnly={values.autoPriceCalculation}
              />
            </div>
          </div>
        ) : null}
      </div>
      <div className="row">
        <div className="col-12 d-flex">
          {discountType === 'FIX' ? (
            <InputWrapper
              id="discountValue"
              value={values.discountFix}
              onChange={(e) => handleChangeDiscount('discountFix', e.target.value)}
              readOnly={!values.autoPriceCalculation}
            />
          ) : (
            <InputWrapper
              id="discountValue"
              value={values.discountPercent}
              onChange={(e) => handleChangeDiscount('discountPercent', e.target.value)}
              readOnly={!values.autoPriceCalculation}
            />
          )}
          <SelectWrap style={{ minWidth: '100px' }}>
            <Select
              label=""
              options={discountTypes}
              value={discountTypes.find((o) => o.value === discountType)}
              onChange={({ value }) => setdiscountType(value)}
              isDisabled={!values.autoPriceCalculation}
            />
          </SelectWrap>
        </div>
      </div>
    </Wrapper>
  );
};

export default PriceBlockWithAutoCalc;
